import { VisitNodePassage } from "../../types";
export const addDifferenceVisitor = (measures) => (args) => {
    if (args?.context?.visitNodePassage !== VisitNodePassage.NodeLast || !args.visitable.data) {
        return;
    }
    const substractValue = {};
    const newLine = { addedDifferenceRow: true, measures: {} };
    args.visitable.data.forEach((da) => {
        measures.forEach((measure) => {
            if (!da.data && da.measures?.[measure] && !da.addedRow) {
                if (substractValue[measure] || substractValue[measure] === 0) {
                    substractValue[measure] -= da.measures[measure];
                }
                else {
                    substractValue[measure] = da.measures[measure];
                }
                if ((substractValue[measure] || substractValue[measure] === 0) && newLine.measures) {
                    newLine.measures[measure] = substractValue[measure];
                }
            }
        });
    });
    args.visitable.data = args.visitable.data.filter((d) => !d.addedDifferenceRow);
    args.visitable.data.push(newLine);
};
